import { render, staticRenderFns } from "./top-review.vue?vue&type=template&id=1580a963&"
import script from "./top-review.vue?vue&type=script&lang=js&"
export * from "./top-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports